<template>
  <div class="border-bottom border-l-0 border-r-0 border-t-0 border-solid border-gray-200 ml-2 lg:ml-3">
    <div class="font-normal text-base leading-6 text-gray-700 pl-3 lg:pl-4 py-4">
      Filter by {{headerType}} Matches by adding your <TextLink :link="ctaUrl" class="ds-text-base m-0" target="_blank">grad year and position -></TextLink>
    </div>
  </div>
</template>

<script>
import { TextLink } from "@sportsrecruits/playbook";
import upperFirst from 'lodash/upperFirst';

export default {
  name: "AddGradYearAndPositionCTA",
  components: {
    TextLink
  },
  props: {
    accordionHeaderType: { 
      type: String,
      validator(value) {
        return ['full', 'potential'].includes(value)
      },
    }
  },
  data: () => ({
    ctaUrl: "/athlete_profile"
  }),
  computed: {
    headerType() {
      return upperFirst(this.accordionHeaderType);
    }
  }
}
</script>